import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/CourseLogDetails/api/courseLogDetailsService'
import { CourseLogDetailsState, ApiCourseLogDetailsResponse } from './types'

const initialState: CourseLogDetailsState = {
  data: {},
}

const courseLogDetailsSlice = createSlice({
  name: 'activityLogCourseLogDetails',
  initialState,
  reducers: {
    dataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiCourseLogDetailsResponse>>) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = courseLogDetailsSlice.actions

export default courseLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
